import {
  GET_BENEFITS_GAMEFICATION,
  GET_BENEFITS_GAMEFICATION_SUCCESS,
  GET_BENEFITS_GAMEFICATION_ERROR,
  GET_BENEFITS_GAMEFICATION_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBenefitsGamification = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFITS_GAMEFICATION:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFITS_GAMEFICATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_BENEFITS_GAMEFICATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BENEFITS_GAMEFICATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBenefitsGamification;
